import { IToastNotification } from 'interface/toastNotification';
import { v4 } from 'uuid';

const initialState: IToastNotification = {
  messages: []
} as any;

const toastNotification = (state = initialState, action: any) => {
  switch (action.type) {
    case 'RECEIVE_MSG': {
      return {
        ...state,
        messages: [ ...state.messages, { id: v4(), msg: action.message, type: action.typeMessage } ]
      };
    }

    case 'CLEAN_MSG': {
      return {
        ...state,
        messages: state.messages.filter(me => me.id !== action.id)
      };
    }

    default:
      return state;
  }
};

export default toastNotification;
